import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/core';
import { SIZE } from './constants';

export const ChartElement = styled.div`
    display: flex;
    flex-direction: row;
    ${getTextTokenPreset('bodyLargeStrong')};
`;

export const LabelsWrapperElement = styled.div`
    flex-grow: 1;
    flex-basis: 50%;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-self: center;
    justify-content: flex-start;
`;

export const PieElement = styled.div`
    flex: 1 1;
    position: relative;
    min-width: ${SIZE}px;
`;

export const LabelElement = styled.div`
    padding-left: 18px;
    position: relative;
`;

export const LabelCircle = styled.div<{ color: string }>`
    background-color: ${({ color }) => color};
    position: absolute;
    border-radius: ${getToken('borderRadiusRound')};
    width: ${getSpacingToken('100')}px;
    height: ${getSpacingToken('100')}px;
    margin-right: ${getSpacingToken('100')}px;
    left: 0;
    top: 8px;
`;

export const ValueWrapperElement = styled.div`
    font-size: 160%;
    line-height: 0.9em;
    position: absolute;
    left: 0;
    top: 0;
    width: ${SIZE}px;
    height: ${SIZE}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const ValueElement = styled.div`
    color: ${(props) => props.color};
    text-align: center;
`;
